module.exports = __webpack_public_path__ + "static/media/black-triangle.ca40af30.svg";